import { CustomApiException } from "@/exceptions/custom-api-error";
import {
  MutationKey,
  useMutation,
  UseMutationOptions,
} from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import useRequestHeaders from "./use-generate-headers";
import { ApiHeaders } from "./headers.types";

// Change MutationFunction to accept a plain object for headers
type MutationFunction<R, T> = (
  data: R,
  headers: ApiHeaders,
  encryption: boolean
) => Promise<AxiosResponse<T>>;

export default function useApiMutation<R, T>(
  mutationKey: MutationKey,
  mutationFunction: MutationFunction<R, T>,
  serviceType: string,
  options?: UseMutationOptions<AxiosResponse<T>, CustomApiException, R>
) {
  const { generateHeaders } = useRequestHeaders(serviceType);

  const mutation = useMutation<AxiosResponse<T>, CustomApiException, R>({
    ...options,
    mutationKey,
    mutationFn: async (data: R) => {
      const headers = generateHeaders();
      return mutationFunction(data, headers, true);
    },
  });

  return mutation;
}
